<template>
  <div class="col-xs-12 text-center" v-if="total">
    <ul class="pagination">
      <li class="paginate_button" @click="clickEnd('pre')">
        <a class="c-pointer"><i class="fa fa-step-backward" aria-hidden="true"></i></a>
      </li>
      <li class="paginate_button"  @click="clickGroup('left')">
        <a class="c-pointer"><i class="fa fa-backward" aria-hidden="true"></i></a>
      </li>
      <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="clickIndex(index)" v-if="pageShow(index)">
        <a class="c-pointer">{{index}}</a>
      </li>
      <li class="paginate_button disabled" v-for="dis in (groupAmount - Math.ceil(pageAmount % 10))" v-if="pageGroup === Math.ceil(pageAmount / groupAmount)">
        <a class="c-pointer">&nbsp;&nbsp;</a>
      </li>
      <li class="paginate_button" @click="clickGroup('right')">
        <a class="c-pointer"><i class="fa fa-forward" aria-hidden="true"></i></a>
      </li>
      <li class="paginate_button" @click="clickEnd('forward')">
        <a class="c-pointer"><i class="fa fa-step-forward" aria-hidden="true"></i></a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    pageAmount: Number,
    groupAmount: Number,
    clickPage: Function,
    isActive: Function,
    total: Number
  },
  data () {
    return {
      pageGroup: 1,
      tableIndex: 1
    }
  },
  methods: {
    clickIndex (index) {
      this.tableIndex = index
      this.clickPage(index)
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.tableIndex = 1
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) {
          this.tableIndex = this.pageAmount
          this.clickPage(this.pageAmount)
        } else {
          this.tableIndex = 1
          this.clickPage(1)
        }
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  },
  watch: {
    tableIndex () {
      const path = this.$route.name
      window.sessionStorage.setItem('Nidin_' + path + '_tIndex', this.tableIndex)
      window.sessionStorage.setItem('Nidin_' + path + '_pGroup', this.pageGroup)
    }
  }
}
</script>
<style lang="sass">
.text-remark
  opacity: .7
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.element-block
  border: 1px solid #eee
  padding: 30px 15px
.choose-modal.modal-dialog
  width: 80%
  min-height: 80vh
  .modal-content
    min-height: 80vh
.btn-choose-element
  margin: 8px
  padding: 10px
  font-size: 18px
  width: calc(20% - 16px)
.btn-choose-element.active
  background-color: #3c8dbc !important
  border-color: #367fa9 !important
  color: #ffffff !important
@media screen and (max-width: 767px)
  .choose-modal.modal-dialog
    width: calc(100vw - 20px)
  .btn-choose-element
    font-size: 16px
    width: calc(100% - 16px)
@media screen and (max-width: 991px)
  .btn-choose-element
    font-size: 16px
    width: calc(50% - 16px)
</style>



// WEBPACK FOOTER //
// Paginate.vue?4ca07490